<template>
  <el-dialog
    title="集采下单"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose"
  >
    <div class="modal-body">
      <el-form label-width="100px">
        <el-form-item label="商品名称：">
          <span>{{addChainProductInfo.prodName}}</span>
        </el-form-item>
        
        <el-form-item label="单位：">
          <span>{{addChainProductInfo.unitName}}</span>
        </el-form-item>
        
        <el-form-item label="商品封面图：">
          <el-image 
            style="width:50px;height:50px"
            :src="addChainProductInfo.coverPhoto"
            :preview-src-list="[addChainProductInfo.coverPhoto]"
          >
            <div slot="error" class="image-slot">
              <img src="/img/noPhoto.jpg" style="width:50px;height:50px">
            </div>
          </el-image>
        </el-form-item>
      </el-form>

      <el-card class="margin-top">
        <div slot="header" class="flex justify-between">
          <span>下单规格数量</span>
        </div>
        <el-table :data="addChainProductInfo.chainProductValueDtos" style="width:100%">
          <el-table-column prop="specName" label="规格名称" align="center"></el-table-column>
          <el-table-column prop="specValue" label="规格值" align="center"></el-table-column>
          <el-table-column prop="price" label="价格" align="center"></el-table-column>
          <el-table-column label="采购数量" align="center">
            <template slot-scope="scope">
              <el-input-number 
                v-model="scope.row.quantity" 
                :min="1" 
                size="small"
              ></el-input-number>
            </template>
          </el-table-column>
          <el-table-column label="定价策略" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.pricingStrategy" size="small">
                <el-option label="固定价格" value="fixed"></el-option>
                <el-option label="浮动价格" value="float"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.remark" size="small"></el-input>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="saveSupplierOrder">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { saveChainInoutOrder } from '@/api/admin/chainProduct/chainProductApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'ViewChainSupplierProduct',
  data() {
    return {
      dialogVisible: false,
      addChainProductInfo: {
        productId: '',
        catalogId: '',
        prodName: '',
        prodDesc: '',
        unitName: '',
        sort: '',
        content: '',
        states: [],
        state: '',
        coverPhoto: '',
        carouselFigurePhotos: [],
        chainProductValueDtos: [],
        productSpecs: [],
        areaCode: '',
        csId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(product) {
      this.dialogVisible = true
      this.addChainProductInfo = {
        ...product,
        shopId: getShopId(),
        chainProductValueDtos: product.chainProductValueDtos.map(item => ({
          ...item,
          quantity: 1,
          pricingStrategy: 'fixed',
          remark: ''
        }))
      }
    },
    saveSupplierOrder() {
      saveChainInoutOrder(this.addChainProductInfo).then(response => {
        const res = response.data
        if (res.code === 0) {
          this.$message.success('采购成功')
          this.dialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      }).catch(error => {
        this.$message.error(error.message)
      })
    },
    handleClose() {
      this.addChainProductInfo = {
        productId: '',
        catalogId: '',
        prodName: '',
        prodDesc: '',
        unitName: '',
        sort: '',
        content: '',
        states: [],
        state: '',
        coverPhoto: '',
        carouselFigurePhotos: [],
        chainProductValueDtos: [],
        productSpecs: [],
        areaCode: '',
        csId: '',
        shopId: ''
      }
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}
</style>